export default {
  state: {
    projectDetail: {}
  },
  mutations: {
    setProjectDetail (state, detail) {
      state.projectDetail = detail
    }
  }
}
